import React, { Component } from 'react';
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";

export class Career extends Component {
  constructor(props) {
                            super(props);
                        
                            this.state = {
                              seo: null,
                            };
                          }
                        
                        async componentDidMount() {
                            const seoData = await getSEO("career");
                        
                            this.setState({
                              seo: seoData,
                            });
                }
  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-4 mb-2 animated slideInLeft">
                  Careers
                </h1>
                <p className="text-muted">
                  Join our team and build your future with Ideal Technoride
                </p>
              </div>
              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link className="text-secondary" to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Careers
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Career Content */}
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">

              <div className="bg-white p-5 shadow-sm rounded">

                {/* Icon */}
                <div className="mb-4">
                  <i className="fa fa-briefcase fa-4x text-primary"></i>
                </div>

                {/* Title */}
                <h3 className="mb-3">No Current Openings</h3>

                {/* Message */}
                <p className="text-muted mb-4">
                  We currently don’t have any open positions, but we’re always
                  looking for talented individuals to join our team in the future.
                </p>

                <p className="text-muted mb-4">
                  If you are passionate about web development, mobile apps, or
                  digital marketing, feel free to share your resume with us.
                </p>

                {/* CTA */}
                <a 
                  href="mailto:idealtechnoride@gmail.com" 
                  className="btn btn-primary px-4 py-2"
                >
                  Send Your Resume
                </a>

              </div>

            </div>
          </div>
        </div>

        {/* Optional Future Section */}
        <div className="container pb-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">

              <div className="bg-light p-4 rounded text-center">
                <h5 className="mb-3">Stay Connected</h5>
                <p className="text-muted mb-0">
                  Follow us on social media or check back later for new opportunities.
                </p>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Career;